import axios from 'axios'

const CoreService = {
  init () {
    // axios.defaults.baseURL = 'https://dev.nacs.com.ng/api/self-service/'
    axios.defaults.baseURL = 'https://revonue.nacs.com.ng/api/self-service/'
    // axios.defaults.baseURL = 'http://localhost:8000/api/self-service/'
    axios.defaults.headers.common.Accept = 'application/json'

    let username = 'fmce.ss.ane@nacs.com.ng'
    let password = '3cc01ae9-12a5-4d83-85a2-24dabda450a2'

    let credentials = btoa(username + ':' + password)

    axios.interceptors.request.use(
      config => {
        config.headers['Authorization'] = `Basic ${credentials}`
        console.log('Interceptor Request: ', config)
        return config
      },
      error => {
        return Promise.reject(error)
      }
    )

    axios.interceptors.response.use(
      response => {
        console.log('Interceptor Response: ', response)
        return response
      },
      error => {
        if (error.status === 401) {
          this.$router.push({ name: 'login' })
        }
        return Promise.reject(error)
      }
    )
  },

  setHeader () {
    let username = 'fmce.ss.ane@nacs.com.ng'
    let password = '3cc01ae9-12a5-4d83-85a2-24dabda450a2'
    let credentials = btoa(username + ':' + password)

    axios.defaults.headers.common['Authorization'] = `Bearer ${credentials}`
  }
}
export default CoreService



// WEBPACK FOOTER //
// ./src/services/core.service.js